import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import videojs from "video.js";
import videozhCN from "video.js/dist/lang/zh-CN.json";
import "video.js/dist/video-js.css";
import $ from 'jquery';

export default class DetailVideo extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            videoOption: {
                autoplay: false,//播放器准备好之后，是否自动播放 【默认false】
                loop: false, //视频播放结束后，是否循环播放
                controls: true,
                responsive: true,
                fluid: true,
                muted: false,//是否静音
                width: 576,
                height: 324,
                controlBar: {
                    fullscreenToggle: true,//显示全屏按钮，默认为true
                    pictureInPictureToggle: false,//隐藏画中画按钮，默认为true
                    volumePanel: false,//隐藏声音面板
                    currentTimeDisplay: true,//显示当前播放时间
                    timeDivider: false,//显示时间分割线
                    durationDisplay: true,//显示总时间
                    remainingTimeDisplay: true,//隐藏剩余时间，
                    audioTrackButton: true //音频跟踪按钮
                },
                sources: [{
                    src:'',
                    type: 'video/mp4'
                }
                ],
                playbackRates: [0.5, 1, 1.5, 2],
                language: 'zh-CN',
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
                aspectRatio: '16:9',
            },
        }
    }

    componentWillMount() {
        let {detailData = {}} = this.props;
        let {storageFile = {}} = detailData;
        let {mp4Path = ""} = storageFile;
        if(this.props.story){
            this.state.videoOption.sources[0].src=this.props.detailData.videoUrl;
        }else{
            this.state.videoOption.sources[0].src=`${mp4Path}`;
        }


        if (this.player) {
            this.player.dispose()
        }
    }

    initVideo(call) {
        //创建视频区域
        let that = this;
        if(this.state.videoOption.sources[0].src && this.videoNode) {
            this.player = videojs(this.videoNode, this.state.videoOption, function onPlayerReady() {
                console.log('onPlayerReady', this);
                call&&call()
                that.setState({});
                // that.handlePlayerReady(that.player)
            });
            videojs.addLanguage("zh-CN", videozhCN);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
            if(nextProps.detailData.id!==this.props.detailData.id){
                let {detailData = {}} = nextProps;
                let {storageFile = {}} = detailData;
                let {mp4Path = ""} = storageFile;
                // let urlHost =window.location.origin;
                // if(urlHost.indexOf('127.0.0.1')>-1) {
                //     urlHost = 'http://192.168.120.50:9241'
                // }

                if(this.props.story){
                    this.state.videoOption.sources[0].src=nextProps.detailData.videoUrl;
                }else{
                    this.state.videoOption.sources[0].src=`${mp4Path}`;
                }
                this.setState({},()=>{
                    this.initVideo(()=>{
                        this.player.src({type: "video/mp4", src:this.props.story?nextProps.detailData.videoUrl:mp4Path});
                        this.player.load(this.state.videoOption.sources[0].src);
                        this.player.pause();
                    })
                })
            }

    }

    componentDidMount() {
        this.initVideo()
    }


    render() {
        return (
            <>
                <div className={"detailVideo"} style={{width: "100%", height: "100%", display:this.state.videoOption.sources[0].src?.length ? 'flex' : 'none'}}>
                    <div style={{
                        width: this.state.videoOption.width,
                        height: this.state.videoOption.height,
                        display: 'flex',
                        margin: 'auto',
                        background: 'black'

                    }}>
                        <div data-vjs-player
                             style={{
                                 'maxWidth': this.state.videoOption.width,
                                 'maxHeight': this.state.videoOption.height,
                             }}>
                            <video ref={node => this.videoNode = node} style={{margin: 'auto',}} id='myVideo'
                                   className="video-js vjs-big-play-centered">
                            </video>
                        </div>
                    </div>
                </div>
                <style>
                    {
                        '.detailVideo .video-js .vjs-progress-control:hover .vjs-mouse-display {display:none}'
                    }
                </style>
            </>

        )
    }

}